import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getTheme() {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/admin/themes-api", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching settings"
                    });
                }
            });
    },
    saveTheme(theme) {
        return axios.post(constants.BASE_URL + "/admin/themes-api", theme, {
            withCredentials: true,
            headers: {
                'Content-Type': 'multipart/form-data'
            } 
        }).then(response => {
                return response.data;

            }).catch(error => {
                return error.response.data;
            });
    },
    removeLogo() {
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + "/admin/themes-api/remove-logo", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while removing logo"
                    });
                }
            });
    },
    removefavicon() {
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + "/admin/themes-api/remove-favicon", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while removing favicon"
                    });
                }
            });
    },
    getAllUserDefinedThemes() {
        var msgType = "updateSuccess";
        let msg = "Error in fetching user defined themes"
        return axios.get(constants.BASE_URL + "/admin/themes-api/user-defined-theme/all", {
            withCredentials: true
        })
            .then(response => {
                const result = response.data
                if(result)
                {
                    if(!result.error)
                    {
                        return result.data
                    }
                    else{
                        
                        msg = result.message;
                      
                        throw msg
                    }
                }
                else{
                    throw msg
                }
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": msg
                    });
                }
            });
    },
    saveUserDefinedTheme(themeDTO) {
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + "/admin/themes-api/user-defined-theme/save", themeDTO, {
            withCredentials: true
        },)
            .then(response => {

                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                let notification = {
                    "msg": "Error while saving user defined theme"
                }
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', notification);
                }
            });
    },

    deleteUserDefinedTheme(id) {
        let msgType = "fetchSuccess";

        return axios.delete(constants.BASE_URL + "/admin/themes-api/user-defined-theme/" + id)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                let notification = {
                    "msg": 'Error in deleting user defined theme'
                }
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', notification);
                }
            });
    },

}
